export const parseNumberInput = (value) => {
    return value ? value.toString().replace(/[^0-9\\.]+/g, '') : value;
};

export const parseNumberValue = (value) => {
    return value ? (Number(value) ? Number(value) : '') : null;
};
